<template>
    <div v-if="this.ShowFilters" class="TableFilter">
        <form class="Form">
            <fieldset>
                <legend>{{ this.risorse['filtraPer'] }}:</legend>
                <div class="FormRow">
                    <div class="FormBoxWide">
                        <input type="search" :placeholder="this.risorse['cercaId']" v-model="this.search" @keypress.enter="this.Prevent($event)" @input="handleInput">
                        <a class="TableFilterButton">&nbsp;</a>
                        <a v-if="!this.MoreFilter" class="TableFilterReset" @click="this.ToggleMoreFilter()">{{ this.risorse['showMoreFilter'] }}</a>
                        <a v-if="this.MoreFilter" class="TableFilterReset" @click="this.ToggleMoreFilter()">{{ this.risorse['hideMoreFilter'] }}</a>
                        <a class="TableFilterReset" @click="this.ResetFilter()">{{ this.risorse['tornaElenco'] }}</a>
                    </div>
                </div>
            </fieldset>
        </form>
        <form class="Form">
            <fieldset>
                <div class="FormRow mt-2" v-if="this.MoreFilter">
                    <div class="FormBoxWide">
                        <input v-if="this.FilterMap?.Prov" class="m-3" type="filter" :placeholder="this.risorse['cercaPerProv']" v-model="this.provincia" @keypress.enter="this.Prevent($event)">
                        <input v-if="this.FilterMap?.Cap" class="m-3" type="filter" :placeholder="this.risorse['cercaPerCap']" v-model="this.cap" @keypress.enter="this.Prevent($event)">
                        <input v-if="this.FilterMap?.Citta" class="m-3" type="filter" :placeholder="this.risorse['cercaPerCitta']" v-model="this.citta" @keypress.enter="this.Prevent($event)">
                        <input v-if="this.FilterMap?.DtDocum" class="m-3" type="date" :placeholder="this.risorse['cercaPerDtDa']" v-model="this.DtDa" @keypress.enter="this.Prevent($event)">
                        <input v-if="this.FilterMap?.DtDocum" class="m-3" type="date" :placeholder="this.risorse['cercaPerDtA']" v-model="this.DtA" @keypress.enter="this.Prevent($event)">
                        <input v-if="this.FilterMap?.TpDocum" class="m-3" type="filter" :placeholder="this.risorse['cercaPerTipoDocum']" v-model="this.TpDocum" @keypress.enter="this.Prevent($event)">
                        <input v-if="this.FilterMap?.Import" class="m-3" type="filter" :placeholder="this.risorse['cercaPerMinOrd']" v-model="this.FromVal" @keypress.enter="this.Prevent($event)">
                        <input v-if="this.FilterMap?.Import" class="m-3" type="filter" :placeholder="this.risorse['cercaPerMaxOrd']" v-model="this.ToVal" @keypress.enter="this.Prevent($event)">
                        <input v-if="this.FilterMap?.DestTxt" class="m-3" type="filter" :placeholder="this.risorse['cercaPerDestinazione']" v-model="this.DestTxt" @keypress.enter="this.Prevent($event)">
                        <input v-if="this.FilterMap?.NumRata" class="m-3" type="filter" :placeholder="this.risorse['cercaPerNumRata']" v-model="this.NumRata" @keypress.enter="this.Prevent($event)">
                        <a class="TableMoreFilterButton ml-2"  @click="this.EmitDeepSearch()">&nbsp;</a>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</template>
<script>
import {risorseMixin} from '@/mixin.js'
export default{
    name: 'TableFilter',
    mixins: [risorseMixin],
    emits:['filtra','moreFilter'],
    data(){
        return {
            search: "",
            showModal: false,
            provincia: "",
            cap: "",
            citta: "",
            DestTxt: "",
            DtDa: "",
            DtA: "",
            TpDocum: "",
            NumRata: "",
            ToVal: "",
            FromVal: "",
            MoreFilter: false
        }
    },
    watch:{
        search: function(){
            this.Filtra();
        },
    },
    props:{
        FilterMap: Object,
        ShowFilters: Boolean
    },
    methods:{
        ResetFilter: function(){
            this.search = "";
            this.provincia = "";
            this.cap = "";
            this.citta = "";
            this.DestTxt = "";
            this.DtDa =  "";
            this.DtA = "";
            this.TpDocum = "";
            this.NumRata = "";
            this.ToVal = "";
            this.FromVal = "";
            this.Filtra();
        },
        EmitDeepSearch: function(){
            this.$emit("moreFilter", 
                {  
                    Key: this.search,
                    DeepFields:{
                        Provincia: this.provincia,
                        Cap: this.cap,
                        Citta: this.citta,
                        DestTxt: this.DestTxt,
                        DtDa: this.DtDa,
                        DtA: this.DtA,
                        TpDocum: this.TpDocum,
                        NumRata: this.NumRata,
                        ToVal: this.ToVal,
                        FromVal: this.FromVal
                    }
                }
            );
        },
        ToggleMoreFilter: function(){
            this.MoreFilter = !this.MoreFilter;
        },
        Filtra: function(){
            this.$emit("filtra", { Key: this.search});
        },
        Prevent: function(ev){
            ev.preventDefault();
            this.EmitDeepSearch();
        },
    }
}
</script>

<style scoped>
.mySpacing{
	margin-top: 10px;
	margin-bottom: 10px;
	margin-left: 15px;
}

.ml-2{
	margin-left: 15px !important;
}
.mt-2{
	margin-top: 35px !important;
}

.m-3{
	margin-top: 15px !important;
	margin-right: 15px !important;
	margin-bottom: 15px !important;
}

a.TableMoreFilterButton{height:30px;width:48px;background-color:var(--customcolor2);text-decoration:none; border-radius: 15px; display:flex;flex-wrap:wrap;align-items:center;justify-content:center;}
a.TableMoreFilterButton::after{height:4px;width:4px;border-right:2px solid var(--customcolor1);border-bottom:2px solid var(--customcolor1);content:"";margin-right:4px;display:inline-block;vertical-align:middle; transform:rotate(-45deg);}
</style>